<template>
  <div class="radio-choices">
    <div v-for="(name, value) in choices" :key="value" class="choices">
      <radio v-model="model" :native-value="value">
        {{ name }}
      </radio>
    </div>
  </div>
</template>

<script>

import Radio from 'Root/buefy/src/components/radio/Radio.vue';

export default {
  props: {
    choices: Object,
    initialValue: String
  },
  data() {
    return {model: this.initialValue};
  },
  watch: {
    model(newValue) {
      this.model = newValue;
      this.$emit('change-choice', newValue);
    }
  },
  components: {Radio}
};
</script>

<style lang="scss" scoped>
.choices:not(:last-child) {
  padding-bottom: 10px;
}
</style>
